var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalAction',{attrs:{"id":_vm.id,"title":_vm.$i18n.t('lb_import_patient'),"hideFooter":""}},[_c('FileUploader',{on:{"handleUploadFile":_vm.handleUploadFile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }